import React, { useContext, useEffect, useRef, useState } from 'react'
import PropTypes from 'prop-types'
import * as Styled from './TabBar.styles'
import { TextContext } from 'hocs/TextContextProvider/TextContextProvider'
import { useMobileSwitch } from 'hooks'
import { Container, Icon } from 'components/atoms'

/**
 * @returns {*}
 * @constructor
 */
const TabBar = ({ data, onTabSelect = () => {}, selectedId = null }) => {
  const isMobile = useMobileSwitch()
  const textContext = useContext(TextContext)
  const indicatorRef = useRef()
  let selectedTabRef = useRef()
  const [indicatorStyles, setIndicatorStyles] = useState({
    top: -10,
    height: 70,
    opacity: 0,
  })
  const [showMobileSelectContainer, setShowMobileSelectContainer] =
    useState(false)

  const updateIndicator = (ref) => {
    if (indicatorRef.current) {
      const refRect = ref.current.getBoundingClientRect()
      const indicatorPadding = 10
      const minIndicatorHeight = 50 + 2 * indicatorPadding // 50px + padding-top and -down á 10px
      const indicatorHeight = Math.max(
        refRect.height + 2 * indicatorPadding,
        minIndicatorHeight
      )
      const topPos = ref.current.offsetTop - indicatorPadding

      setIndicatorStyles({
        top: topPos,
        opacity: 1,
        height: indicatorHeight,
      })
    }
  }

  useEffect(() => {
    if (selectedTabRef.current) {
      updateIndicator(selectedTabRef)
    }
  }, [selectedId])

  const handleTabClick = (id, ref) => {
    // if isMobile => toggle mobile select container
    // otherwise select item directly
    if (isMobile) {
      if (data && data.length > 1) setShowMobileSelectContainer(true)
    } else {
      updateIndicator(ref)
      onTabSelect(id)
    }
  }

  const handleMobileSelectClick = (id) => {
    setShowMobileSelectContainer(false)
    onTabSelect(id)
  }

  return (
    <Styled.TabBar style-open={ isMobile ? showMobileSelectContainer : null }>
      <Styled.SelectedTabIndicator
        ref={ indicatorRef }
        styles={ indicatorStyles }
      />

      {/* desktop view */}
      {data &&
        data.map((item, index) => {
          const ref = React.createRef()
          if (item.hospitalId === selectedId) {
            selectedTabRef = ref
          }
          return (
            <Styled.TabItem
              key={ index }
              ref={ ref }
              onClick={ () => handleTabClick(item.hospitalId, ref) }
              className={ item.hospitalId === selectedId ? 'selected' : '' }>
              <span>
                {item.name}{' '}
                {item.treatments && (
                  <span className={ 'treatments' }>
                    {item.treatments.cases}&nbsp;
                    {item.treatments.cases === 1
                      ? textContext['general.treatments.short.singular']
                      : textContext['general.treatments.short']}
                  </span>
                )}
              </span>
            </Styled.TabItem>
          )
        })}

      {/* mobile select box */}
      {isMobile && showMobileSelectContainer && (
        <Container isFlat={ true } className={ 'container-mobile-tab-nav' }>
          {data &&
            data.map((item, index) => (
              <Styled.TabMobileSelect
                key={ index }
                onClick={ () => handleMobileSelectClick(item.hospitalId) }
                className={ item.hospitalId === selectedId ? 'selected' : '' }>
                {item.name}{' '}
                {item.treatments && (
                  <span className={ 'treatments' }>
                    {item.treatments.cases}&nbsp;
                    {item.treatments.cases === 1
                      ? textContext['general.treatments.short.singular']
                      : textContext['general.treatments.short']}
                  </span>
                )}
              </Styled.TabMobileSelect>
            ))}
        </Container>
      )}
      {isMobile && data && data.length > 1 && (
        <Icon className={ 'arrow-icon-mobile icon-f-arrow-down' } />
      )}
    </Styled.TabBar>
  )
}

TabBar.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      hospitalId: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      treatments: PropTypes.shape({
        cases: PropTypes.number,
      }),
    })
  ),
  onTabSelect: PropTypes.func,
  selectedId: PropTypes.string,
}

export default TabBar
